import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

// import { useSelector } from "react-redux";
import {
  Table,
  Select as TagSelector,
  Spin,
  Empty,
  Input,
  DatePicker,
  Drawer,
  Button,
  Card,
  Divider,
  Tag,
  Avatar,
} from "antd";
import Swal from "sweetalert2";
// import FeatherIcon from "feather-icons-react";
// import { Eye, Mail } from "feather-icons-react/build/IconComponents";
import CommonFooter from "../../../../../core/common/footer/commonFooter";
import { BASE_CRM_URL } from "../../../../components/config/config";
import dayjs from "dayjs";
import { CloseOutlined } from "@ant-design/icons";
import { EditOutlined } from "@ant-design/icons";
import axios from "axios";
const EstimateInfo = () => {
  //   const [activeTab, setActiveTab] = useState("estimate");
  //    const dataSource = useSelector((state) => state.rootReducer.CRMCustomers);
  const currentDateTime = new Date().toLocaleString();

  // Static IP Address
  const ipAddress = "192.168.1.1"; // You can replace this with any static IP address

  const columns = [
    {
      title: "#",
      dataIndex: "id",
      sorter: (a, b) => a.id?.length - b.id?.length,
    },

    {
      title: "Name",
      dataIndex: "company",
      sorter: (a, b) => a.company?.length - b.company?.length,
      render: (text) =>
        text?.length > 15 ? `${text.substring(0, 15)}...` : text,
    },

    {
      title: "Status",
      dataIndex: "primaryContact",
      sorter: (a, b) => a.primaryContact?.length - b.primaryContact?.length,
      render: (text) =>
        text?.length > 15 ? `${text.substring(0, 15)}...` : text,
    },
    {
      title: "Start Date",
      dataIndex: "primaryEmail",
      sorter: (a, b) => a.primaryEmail?.length - b.primaryEmail?.length,
      render: (text) =>
        text?.length > 15 ? `${text.substring(0, 15)}...` : text,
    },
    {
      title: "Due Date",
      dataIndex: "phone",
      sorter: (a, b) => a.phone?.length - b.phone?.length,
      render: (text) =>
        text?.length > 15 ? `${text.substring(0, 15)}...` : text,
    },
    {
      title: "Assigned to",
      dataIndex: "dateCreated",
      sorter: (a, b) => a.dateCreated?.length - b.dateCreated?.length,
      render: (date) => date?.split(" ")[0],
    },
    {
      title: "Tags",
      dataIndex: "renewalDate",
      sorter: (a, b) => a.renewalDate?.length - b.renewalDate?.length,
      render: (date) => date?.split(" ")[0],
    },
    {
      title: "Priority",
      dataIndex: "renewalDate",
      sorter: (a, b) => a.renewalDate?.length - b.renewalDate?.length,
      render: (date) => date?.split(" ")[0],
    },
  ];
  const columns1 = [
    {
      title: "Description",
      dataIndex: "company",
      sorter: (a, b) => a.company?.length - b.company?.length,
      render: (text) =>
        text?.length > 15 ? `${text.substring(0, 15)}...` : text,
    },

    {
      title: "Date",
      dataIndex: "primaryContact",
      sorter: (a, b) => a.primaryContact?.length - b.primaryContact?.length,
      render: (text) =>
        text?.length > 15 ? `${text.substring(0, 15)}...` : text,
    },
    {
      title: "Remind",
      dataIndex: "primaryEmail",
      sorter: (a, b) => a.primaryEmail?.length - b.primaryEmail?.length,
      render: (text) =>
        text?.length > 15 ? `${text.substring(0, 15)}...` : text,
    },
    {
      title: "is notified",
      dataIndex: "phone",
      sorter: (a, b) => a.phone?.length - b.phone?.length,
      render: (text) =>
        text?.length > 15 ? `${text.substring(0, 15)}...` : text,
    },
    {
      title: "Assigned to",
      dataIndex: "dateCreated",
      sorter: (a, b) => a.dateCreated?.length - b.dateCreated?.length,
      render: (date) => date?.split(" ")[0],
    },
  ];

  const userDetails = JSON.parse(sessionStorage.getItem("userDetails"));
  const userId = userDetails?.staffid;

  const { id } = useParams();

  console.log(id, "idddddddddddddddddd"); // e.g. 2

  const [estimateDetails, setEstimateDetails] = useState(null);

  console.log(estimateDetails, "estimateDetails");

  const getEstimates = async (id) => {
    try {
      const response = await fetch(
        `${BASE_CRM_URL}estimates/GetEstimate/${id}`
      );

      const data = await response.json();

      setEstimateDetails(data);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getEstimates(id);
  }, []);







  

  const [reminders, setReminders] = useState([]);
  const [remindersLoading, setRemindersLoading] = useState(false);

  const [addReminderLoading, setAddReminderLoading] = useState(false);
  const [updateReminderLoading, setUpdateReminderLoading] = useState(false);

  const [editingReminderId, setEditingReminderId] = useState(null);

  const [reminderData, setReminderData] = useState({
    description: "",
    date: null,
    staff: userId,
  });

  const [editReminderData, setEditReminderData] = useState({
    description: "",
    date: null,
    staff: userId,
  });

  const [staffList, setStaffList] = useState([]);
  const [staffLoading, setStaffLoading] = useState(false);

  const fetchReminders = async () => {
    try {
      setRemindersLoading(true);

      const response = await fetch(
        `${BASE_CRM_URL}reminder/GetReminders?rel_id=${id}&rel_type=Estimate&staffid=0`
      );

      const data = await response.json();

      if (data.Status) {
        setReminders(data.ResultData || []);
      } else {
        setReminders([]);
      }
    } catch (error) {
      console.error(error);
      setReminders([]);
    } finally {
      setRemindersLoading(false);
    }
  };

  const fetchStaff = async () => {
    try {
      setStaffLoading(true);

      const response = await fetch(`${BASE_CRM_URL}staff/GetStaffDropdown`);
      const data = await response.json();

      if (data.ResultData) {
        setStaffList(data.ResultData);
      } else {
        setStaffList([]);
      }
    } catch (error) {
      console.error("Error fetching staff:", error);
      setStaffList([]);
    } finally {
      setStaffLoading(false);
    }
  };
  const handleAddReminder = async () => {
    if (!reminderData.description.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Description Required",
        text: "Please enter reminder description.",
      });
      return;
    }

    if (!reminderData.date) {
      Swal.fire({
        icon: "warning",
        title: "Reminder Date Required",
        text: "Please select reminder date.",
      });
      return;
    }

    try {
      setAddReminderLoading(true);
      const userDetails = JSON.parse(sessionStorage.getItem("userDetails"));
      const userId = userDetails?.staffid;
      const response = await fetch(`${BASE_CRM_URL}reminder/AddReminder`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          description: reminderData.description,
          date: dayjs(reminderData.date).format("YYYY-MM-DD HH:mm:ss"),
          rel_id: id,
          rel_type: "Estimate",
          staff: reminderData.staff,
          creator: userId,
        }),
      });

      const data = await response.json();

      if (data.Status) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: data.Message,
          timer: 1500,
          showConfirmButton: false,
        });

        setReminderData({
          description: "",
          date: null,
          staff: userId,
        });

        fetchReminders();
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: data.Message,
        });
      }
    } catch (error) {
      console.error(error);

      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong.",
      });
    } finally {
      setAddReminderLoading(false);
    }
  };

  const handleEditReminder = (reminder) => {
    setEditingReminderId(reminder.id);

    setEditReminderData({
      description: reminder.description,
      date: dayjs(reminder.date),
      staff: reminder.staff,
    });
  };

  const handleCancelReminderEdit = () => {
    setEditingReminderId(null);

    setEditReminderData({
      description: "",
      date: null,
      staff: userId,
    });
  };

  const handleUpdateReminder = async () => {
    if (!editReminderData.description.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Description Required",
        text: "Please enter reminder description.",
      });
      return;
    }

    try {
      setUpdateReminderLoading(true);

      const response = await fetch(`${BASE_CRM_URL}reminder/UpdateReminder`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: editingReminderId,
          description: editReminderData.description,
          date: dayjs(editReminderData.date).format("YYYY-MM-DD HH:mm:ss"),
          staff: editReminderData.staff,
        }),
      });

      const data = await response.json();

      if (data.Status) {
        Swal.fire({
          icon: "success",
          title: "Updated",
          text: data.Message,
          timer: 1500,
          showConfirmButton: false,
        });

        setEditingReminderId(null);

        fetchReminders();
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: data.Message,
        });
      }
    } catch (error) {
      console.error(error);

      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong.",
      });
    } finally {
      setUpdateReminderLoading(false);
    }
  };

  useEffect(() => {
    fetchReminders();
    fetchStaff();
  }, []);

  //notes code

  const [notes, setNotes] = useState([]);
  const [notesLoading, setNotesLoading] = useState(false);
  const [addNoteLoading, setAddNoteLoading] = useState(false);
  const [noteData, setNoteData] = useState({
    description: "",
    date_contacted: null,
  });
  const [editingNoteId, setEditingNoteId] = useState(null);
  const [editNoteData, setEditNoteData] = useState({
    description: "",
  });
  const [updateNoteLoading, setUpdateNoteLoading] = useState(false);

  const fetchNotes = async () => {
    try {
      setNotesLoading(true);

      const response = await fetch(
        `${BASE_CRM_URL}notes/GetNotes?rel_id=${id}&rel_type=Estimate`
      );

      const data = await response.json();

      if (data.Status) {
        setNotes(data.ResultData || []);
      } else {
        setNotes([]);
      }
    } catch (error) {
      console.error("Error fetching notes:", error);
      setNotes([]);
    } finally {
      setNotesLoading(false);
    }
  };

  const handleEditNote = (note) => {
    setEditingNoteId(note.id);

    setEditNoteData({
      description: note.description,
    });
  };

  const handleUpdateNote = async () => {
    if (!editNoteData.description.trim()) {
      Swal.fire({
        icon: "error",
        title: "Please enter a note.",
      });
      return;
    }

    try {
      setUpdateNoteLoading(true);

      const response = await fetch(`${BASE_CRM_URL}notes/UpdateNote`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: editingNoteId,
          description: editNoteData.description,
        }),
      });

      const data = await response.json();

      if (data.Status) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: data.Message,
          timer: 2000,
          showConfirmButton: false,
        });

        setEditingNoteId(null);

        setEditNoteData({
          description: "",
        });

        fetchNotes();
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: data.Message,
        });
      }
    } catch (error) {
      console.error(error);
    } finally {
      setUpdateNoteLoading(false);
    }
  };

  const handleCancelEdit = () => {
    setEditingNoteId(null);

    setEditNoteData({
      description: "",
    });
  };

  const handleAddNote = async () => {
    if (!noteData.description.trim()) {
      Swal.fire({
        icon: "error",
        title: "Please enter a note.",
      });
      return;
    }

    try {
      setAddNoteLoading(true);
      const userDetails = JSON.parse(sessionStorage.getItem("userDetails"));
      const userId = userDetails?.staffid;
      const response = await fetch(`${BASE_CRM_URL}notes/AddNote`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          rel_id: id,
          rel_type: "Estimate",
          description: noteData.description,
          addedfrom: userId,
        }),
      });

      const data = await response.json();

      if (data.Status) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: data.Message,
          timer: 2000,
          showConfirmButton: false,
        });

        setNoteData({
          description: "",
          date_contacted: null,
        });

        fetchNotes();
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: data.Message,
        });
      }
    } catch (error) {
      console.error(error);
    } finally {
      setAddNoteLoading(false);
    }
  };

  useEffect(() => {
    fetchNotes();
  }, []);

  const [noteDrawerOpen, setNoteDrawerOpen] = useState(false);

  const [reminderDrawerOpen, setReminderDrawerOpen] = useState(false);
  const handleCloseReminderDrawer = () => {
    setReminderDrawerOpen(false);
    setEditingReminderId(null);

    setReminderData({
      description: "",
      date: null,
      staff: null,
    });

    setEditReminderData({
      description: "",
      date: null,
      staff: null,
    });
  };








  // active log code 

  const [activityDrawerOpen, setActivityDrawerOpen] = useState(false);
  const [activityLog, setActivityLog] = useState([]);

  console.log(activityLog, "activityyyyyyyyyyy");
  const [activityLoading, setActivityLoading] = useState(false);
  const getActivityLog = async (id) => {
    try {
      setActivityLoading(true);

      const response = await axios.get(
        `${BASE_CRM_URL}estimates/GetEstimateActivitylog?EstimateId=${id}`
      );

      if (response.data.Status) {
        setActivityLog(response.data.ResultData || []);
      } else {
        setActivityLog([]);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setActivityLoading(false);
    }
  };
  useEffect(() => {
    getActivityLog(id);
  }, []);

  return (
    <div className="page-wrapper">
      <div className="content pt-2">
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb d-flex justify-content-between w-100">
            <div className="d-flex align-items-center">
              <li className="breadcrumb-item">
                <Link to="/crm/estimates">
                  <i className="fas fa-home fa-lg" />
                </Link>
              </li>
              <h4 className="breadcrumb-item mb-0" aria-current="page">
                Estimate Info
              </h4>
            </div>
            <ul
              className="nav nav-tabs nav-tabs-bottom"
              id="myTab"
              role="tablist"
            >
              <li className="nav-item" role="presentation">
                <Link
                  className="nav-link active"
                  id="estimate-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#estimate-tab-pane"
                  type="button"
                  role="tab"
                  aria-controls="estimate-tab-pane"
                  aria-selected="true"
                >
                  Estimate
                </Link>
              </li>
              <li className="nav-item" role="presentation">
                <Link
                  className="nav-link"
                  id="tasks-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#tasks-tab-pane"
                  type="button"
                  role="tab"
                  aria-controls="tasks-tab-pane"
                  aria-selected="false"
                >
                  Tasks
                </Link>
              </li>
              <li className="nav-item" role="presentation">
              <Link
                  to="#"
                  className="nav-link"
                  onClick={(e) => {
                    e.preventDefault();
                    setActivityDrawerOpen(true);
                  }}
                >
                  Activelog
                </Link>
              </li>
              <li className="nav-item" role="presentation">
                <Link
                  to="#"
                  className="nav-link"
                  onClick={(e) => {
                    e.preventDefault();
                    setReminderDrawerOpen(true);
                  }}
                >
                  Reminders
                </Link>
              </li>
              <li className="nav-item" role="presentation">
                <Link
                  to="#"
                  className="nav-link"
                  onClick={(e) => {
                    e.preventDefault();
                    setNoteDrawerOpen(true);
                  }}
                >
                  Notes
                </Link>
              </li>
            </ul>

            {/* Back to List Button */}
            <div className="page-btn d-flex justify-content-between align-items-center flex-wrap gap-2">
              <span className="badge  px-3 py-2 g-2">
                {estimateDetails?.status || "Draft"}
              </span>

              {/* Right - Buttons */}
              <div className="d-flex align-items-center gap-2">
                {/* <Link className="btn btn-secondary btn-sm">
                  <i className="fas fa-edit"></i>
                </Link> */}
                <Link className="btn btn-info  btn-sm">
                  <i className="fas fa-envelope"></i>
                </Link>
                <Link className="btn btn-primary  btn-sm">
                  More <i className="fas fa-chevron-down"></i>
                </Link>
                <Link className="btn btn-primary  btn-sm">
                  <i className="fas fa-check"></i> INV-2025/1786
                </Link>
                <Link to="/crm/estimates" className="btn btn-dark btn-sm">
                  <i className="ti ti-arrow-left"></i>
                </Link>
              </div>
            </div>
          </ol>
        </nav>

        <div className="container-fluid">
          {/* Card with Tabs */}

          <div className="card shadow proposal-summary">
            <div className="card-body pb-1 ">
              <div className="row align-items-center">
                <div className="col-md-3 col-sm-6 mb-2 border-end text-center">
                  <div className="d-inline-flex align-items-center">
                    <span className="fw-bold me-2">Estimate No:</span>
                    <span className="fw-bold text-danger">EST-1234</span>
                  </div>
                </div>

                <div className="col-md-3 col-sm-6 mb-2 border-end text-center">
                  <div className="d-inline-flex align-items-center">
                    <i className="fa-regular fa-calendar me-2"></i>
                    <span className="fw-bold me-2">Issued On:</span>
                    <span className="fw-bold">
                      {dayjs(estimateDetails?.Estimate.datecreated).format(
                        "DD-MM-YYYY"
                      )}
                    </span>
                  </div>
                </div>

                <div className="col-md-3 col-sm-6 mb-2 border-end text-center">
                  <div className="d-inline-flex align-items-center">
                    <i className="fa-regular fa-clock  me-2"></i>
                    <span className="fw-bold me-2">Valid Until:</span>
                    <span className="fw-bold">
                      {dayjs(estimateDetails?.Estimate.expirydate).format(
                        "DD-MM-YYYY"
                      )}
                    </span>
                  </div>
                </div>

                <div className="col-md-3 col-sm-6 mb-2 text-center">
                  <div className="d-inline-flex align-items-center">
                    <i className="fa-solid fa-indian-rupee-sign me-2"></i>
                    <span className="fw-bold me-2">Total:</span>
                    <span className="fw-bold text-success">
                      ₹{" "}
                      {Number(estimateDetails?.Estimate.total).toLocaleString()}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="card shadow ">
            <div className="card-body pt-1">
              <div className="tab-content" id="myTabContent">
                {/* Estimate Tab Content */}
                <div
                  className="tab-pane fade show active"
                  id="estimate-tab-pane"
                  role="tabpanel"
                  aria-labelledby="estimate-tab"
                >
                  <div className="row mt-3">
                    <div className="col-5">
                      <h6 className=" fw-bold mb-3">
                        <i className="fa-solid fa-building me-2"></i>
                        Perennial Code IT Consultants Pvt. Ltd.
                      </h6>

                      <p className="mb-1">
                        <i className="fa-solid fa-map-location-dot  me-2"></i>
                        Vidya Nagar, Hyderabad, Telangana, INDIA - 500044
                      </p>

                      <p className="mb-1">
                        <i className="fa-solid fa-file-invoice  me-2"></i>
                        GSTIN: 36AAHCP3604R1ZM
                      </p>

                      <p className="mb-0">
                        <i className="fa-solid fa-phone-volume  me-2"></i>
                        +91 4048513363, +91 8297230010
                      </p>
                    </div>
                    <div className="col-3 d-flex justify-content-start align-items-end">
                      <div className="text-start">
                        <p className="mb-0">
                          <i className="fa-solid fa-user-check me-2"></i>
                          <strong>CreatedBy:</strong>{" "}
                          {estimateDetails?.AddedByName || "-"}
                        </p>
                      </div>
                    </div>
                    <div className="col-4 d-flex justify-content-end">
                      <div className="text-end">
                        <h6>To:</h6>
                        <p className="mb-1">
                          {" "}
                          <i className="fa-solid fa-user-tie  me-2"></i>
                          {estimateDetails?.Estimate.ClientName || "-"}
                        </p>
                        <p className="mb-1">
                          {" "}
                          <i className="fa-solid fa-city  me-2"></i>
                          {estimateDetails?.Estimate.billing_street},{" "}
                          {estimateDetails?.Estimate.billing_city},{" "}
                          {estimateDetails?.Estimate.billing_state} -{" "}
                          {estimateDetails?.Estimate.billing_zip}
                        </p>

                        <p>
                          GSTIN: <strong>36AVKPG0403A1ZE</strong>
                        </p>
                        <p className="mb-2">
                          <i className="fa-solid fa-phone  me-2"></i>
                          {estimateDetails?.Estimate.phone || "-"},{" "}
                          <i className="fa-solid fa-envelope  me-2"></i>
                          {estimateDetails?.Estimate.email || "-"}
                        </p>
                      </div>
                    </div>
                  </div>

                  <hr />

                  {/* Table Section */}
                  <div className="table-responsive">
                    <table className="table table-bordered table-hover align-middle mb-0">
                      <thead className="table-primary">
                        <tr>
                          <th style={{ width: 60 }}>#</th>
                          <th>Item</th>
                          <th className="text-center">Qty</th>
                          <th className="text-end">Rate</th>
                          <th className="text-end">Tax</th>
                          <th className="text-end">Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        {estimateDetails?.Itemable?.map((item, index) => {
                          const amount = Number(item.qty) * Number(item.rate);

                          return (
                            <tr key={item.id}>
                              <td className="fw-semibold">{index + 1}</td>

                              <td
                                style={{
                                  maxWidth: "300px",
                                  whiteSpace: "normal",
                                  wordBreak: "break-word",
                                }}
                              >
                                <div className="fw-semibold text-dark">
                                  {item.description}
                                </div>
                              </td>

                              <td className="text-center">
                                <span className="badge bg-light text-dark border">
                                  {item.qty}
                                </span>
                              </td>

                              <td className="text-end">
                                ₹ {Number(item.rate).toLocaleString()}
                              </td>

                              <td className="text-end">
                                ₹{" "}
                                {(
                                  Number(estimateDetails?.Estimate.total_tax) /
                                  estimateDetails?.Itemable.length
                                ).toLocaleString(undefined, {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}
                              </td>

                              <td className="text-end fw-bold text-success">
                                ₹ {amount.toLocaleString()}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                  <div className="row mt-2">
                    {/* <div className="col-8 text-start">
                      <p>
                        <strong>Note:</strong>
                      </p>
                      <p>Payment Terms: 100% Advance.</p>

                      <p>
                        <strong>Axis Bank Details:</strong>
                      </p>
                      <p>Account Name: Perennial Code IT Consultants Pvt Ltd</p>
                      <p>Bank: Axis Bank, Nallakunta, Hyderabad</p>
                      <p>Account# 914020041433504</p>
                      <p>IFC Code UTIB0001381</p>

                      <p>
                        <strong>Terms & Conditions</strong>
                      </p>
                      <p>
                      {estimateDetails?.Estimate.terms}
                      </p>
                    </div> */}
                    <div className="col-8">
                      <div className="row g-3">
                        {/* Bank Details */}
                        <div className="col-md-6">
                          <div
                            className="card h-100 border-0"
                            style={{
                              background: "#eef7ff",
                              borderRadius: "12px",
                            }}
                          >
                            <div className="card-body">
                              <div className="d-flex align-items-center mb-3">
                                <div
                                  className="d-flex align-items-center justify-content-center me-2"
                                  style={{
                                    width: "38px",
                                    height: "38px",
                                    borderRadius: "8px",
                                    background: "#d9edff",
                                  }}
                                >
                                  <i
                                    className="ti ti-building-bank"
                                    style={{
                                      fontSize: "20px",
                                      color: "#1677ff",
                                    }}
                                  ></i>
                                </div>

                                <h6 className="mb-0 fw-semibold">
                                  Axis Bank Details
                                </h6>
                              </div>

                              <div className="mb-2">
                                <small className="text-muted d-block">
                                  Account Name
                                </small>
                                <span className="fw-medium">
                                  Perennial Code IT Consultants Pvt Ltd
                                </span>
                              </div>

                              <div className="mb-2">
                                <small className="text-muted d-block">
                                  Bank
                                </small>
                                <span className="fw-medium">
                                  Axis Bank, Nallakunta, Hyderabad
                                </span>
                              </div>

                              <div className="row">
                                <div className="col-md-7">
                                  <small className="text-muted d-block">
                                    Account Number
                                  </small>
                                  <span className="fw-medium">
                                    914020041433504
                                  </span>
                                </div>

                                <div className="col-md-5">
                                  <small className="text-muted d-block">
                                    IFSC Code
                                  </small>
                                  <span className="fw-medium">UTIB0001381</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Terms & Conditions */}
                        <div className="col-md-6">
                          <div
                            className="card h-100 border-0"
                            style={{
                              background: "#f8faff",
                              borderRadius: "12px",
                            }}
                          >
                            <div className="card-body">
                              <div className="d-flex align-items-center mb-3">
                                <div
                                  className="d-flex align-items-center justify-content-center me-2"
                                  style={{
                                    width: "38px",
                                    height: "38px",
                                    borderRadius: "8px",
                                    background: "#e9f1ff",
                                  }}
                                >
                                  <i
                                    className="ti ti-file-description"
                                    style={{
                                      fontSize: "20px",
                                      color: "#1677ff",
                                    }}
                                  ></i>
                                </div>

                                <h6 className="mb-0 fw-semibold">
                                  Terms & Conditions
                                </h6>
                              </div>

                              <p className="text-muted mb-0">
                                {estimateDetails?.Estimate?.terms ||
                                  "No terms available."}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-4 text-end">
                      <table className="table text-end" style={{ height: 200 }}>
                        <tbody>
                          <tr>
                            <td>Sub Total</td>
                            <td>
                              ₹{" "}
                              {Number(
                                estimateDetails?.Estimate.subtotal
                              ).toLocaleString()}
                            </td>
                          </tr>

                          <tr>
                            <td>Total Tax</td>
                            <td>
                              ₹{" "}
                              {Number(
                                estimateDetails?.Estimate.total_tax
                              ).toLocaleString()}
                            </td>
                          </tr>

                          <tr>
                            <td>Adjustment</td>
                            <td>
                              ₹{" "}
                              {Number(
                                estimateDetails?.Estimate.adjustment
                              ).toLocaleString()}
                            </td>
                          </tr>

                          <tr className="table-primary bg-light">
                            <td>Total</td>
                            <td>
                              ₹{" "}
                              {Number(
                                estimateDetails?.Estimate.total
                              ).toLocaleString()}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                {/* Other Tab Content (Tasks, Activity, etc.) */}
                <div
                  className="tab-pane fade"
                  id="tasks-tab-pane"
                  role="tabpanel"
                  aria-labelledby="tasks-tab"
                >
                  <div>
                    <div className="d-flex justify-content-end my-4">
                      {/* Right section with buttons */}
                      <div className="d-flex justify-content-around">
                        <div className="me-3 ">
                          <Link
                            to="edit-sales.html"
                            className="btn btn-success btn-sm"
                            data-bs-toggle="offcanvas"
                            data-bs-target="#offcanvasRightNewCustomer"
                            aria-controls="#offcanvasRightNewCustomer"
                          >
                            <i className="ti ti-circle-plus fs-4 "> </i>
                          </Link>
                        </div>
                      </div>
                    </div>

                    <div
                      className="card table-list-card"
                      style={{ marginTop: "-1rem" }}
                    >
                      <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                        <div className="search-set"></div>
                        <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                          <div className="dropdown me-2">
                            <Link
                              to="#"
                              className="btn btn-white btn-md d-inline-flex align-items-center"
                              data-bs-toggle="modal"
                              data-bs-target="#add-units"
                            >
                              <i className="ti ti-filter me-1"></i>
                              Filter
                            </Link>
                          </div>
                          <div className="dropdown me-2">
                            <Link
                              to="#"
                              className="dropdown-toggle btn btn-white btn-md d-inline-flex align-items-center"
                              data-bs-toggle="dropdown"
                            >
                              Employee
                            </Link>
                            <ul className="dropdown-menu dropdown-menu-end p-3">
                              <li>
                                <Link
                                  to="#"
                                  className="dropdown-item rounded-1"
                                >
                                  Harwinder R
                                </Link>
                              </li>
                              <li>
                                <Link
                                  to="#"
                                  className="dropdown-item rounded-1"
                                >
                                  Raghavendra ND
                                </Link>
                              </li>
                              <li>
                                <Link
                                  to="#"
                                  className="dropdown-item rounded-1"
                                >
                                  Raghu H
                                </Link>
                              </li>
                              <li>
                                <Link
                                  to="#"
                                  className="dropdown-item rounded-1"
                                >
                                  RamaKrishna R
                                </Link>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="card-body">
                        <div className="table-responsive">
                          <Table columns={columns} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="tab-pane fade"
                  id="activity-tab-pane"
                  role="tabpanel"
                  aria-labelledby="activity-tab"
                >
                  <div className="p-3 border rounded bg-white">
                    <ul className="list-unstyled">
                      <li className="mb-3">
                        <small className="text-muted">2 DAYS AGO</small>
                        <div>
                          <strong>Pavani G</strong> - Created the estimate
                        </div>
                      </li>
                      <li className="mb-3">
                        <small className="text-muted">19 HRS AGO</small>
                        <div>
                          <strong>Pavani G</strong> - Marked estimate as
                          Accepted
                        </div>
                      </li>
                      <li>
                        <small className="text-muted">19 HRS AGO</small>
                        <div>
                          <strong>Pavani G</strong> - Converted this estimate to
                          invoice.
                          <a href="#" className="text-primary">
                            INV - 2025/1380
                          </a>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <div
                  className="tab-pane fade"
                  id="reminders-tab-pane"
                  role="tabpanel"
                  aria-labelledby="reminders-tab"
                >
                  <div className="d-flex justify-content-end my-4">
                    {/* Right section with buttons */}
                    <div className="d-flex justify-content-around">
                      <div className="me-3 ">
                        <Link
                          to="edit-sales.html"
                          className="btn btn-primary text-white"
                          data-bs-toggle="offcanvas"
                          data-bs-target="#offcanvasRightNewCustomer"
                          aria-controls="#offcanvasRightNewCustomer"
                        >
                          <i className="fa fa-bell me-1"></i>
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div className="card table-list-card">
                    <div className="d-flex flex-wrap row-gap-3 card-header align-items-center justify-content-between">
                      <div className="search-set"></div>
                      <div className="d-flex flex-wrap row-gap-3 table-dropdown align-items-center my-xl-auto right-content">
                        <div className="dropdown me-2">
                          <Link
                            to="#"
                            className="d-inline-flex btn btn-md btn-white dropdown-toggle align-items-center"
                            data-bs-toggle="dropdown"
                          >
                            Location
                          </Link>
                          <ul className="dropdown-menu dropdown-menu-end p-3">
                            <li>
                              <Link to="#" className="dropdown-item rounded-1">
                                Hyderabad
                              </Link>
                            </li>
                            <li>
                              <Link to="#" className="dropdown-item rounded-1">
                                Bangalore
                              </Link>
                            </li>
                            <li>
                              <Link to="#" className="dropdown-item rounded-1">
                                NewYork
                              </Link>
                            </li>
                            <li>
                              <Link to="#" className="dropdown-item rounded-1">
                                Germany
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="card-body">
                      <div className="table-responsive">
                        <Table columns={columns1} />
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="tab-pane fade"
                  id="notes-tab-pane"
                  role="tabpanel"
                  aria-labelledby="notes-tab"
                >
                  <div className="container mt-5">
                    <div className="row">
                      <div className="col-12">
                        <textarea
                          className="form-control"
                          rows="4"
                          placeholder="Enter text here..."
                        />
                      </div>
                    </div>
                    <div className="row mt-2">
                      <div className="col-12 text-end">
                        <button className="btn btn-primary">Add Note</button>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="tab-pane fade"
                  id="terms-tab-pane"
                  role="tabpanel"
                  aria-labelledby="terms-tab"
                >
                  <div className="container mt-2">
                    <h5 className="mb-">Tracked Emails Sent</h5>
                    <table className="table table-bordered">
                      <thead className="table-light">
                        <tr>
                          <th>Date</th>
                          <th>Subject</th>
                          <th>To</th>
                          <th>Opened</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>19/03/2025 18:51:56</td>
                          <td>
                            Proposal for Safety Road Barrier With Number
                            PRO-4337 Created
                          </td>
                          <td>managingpartner@trustservices.co.in</td>
                          <td>
                            <span className="badge bg-success">Opened</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div
                  className="tab-pane fade"
                  id="bank-tab-pane"
                  role="tabpanel"
                  aria-labelledby="bank-tab"
                >
                  <div className="container mt-2">
                    <div className="text-start">
                      <div className="mb-2">
                        <p>
                          <span className="fw-bold">Date :</span>
                          {currentDateTime}
                        </p>
                      </div>
                      <div>
                        <p>
                          <span className="fw-bold">IP Address :</span>
                          {ipAddress}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Drawer
          title="Notes"
          open={noteDrawerOpen}
          onClose={() => setNoteDrawerOpen(false)}
          width={500}
          maskClosable={true}
          destroyOnClose
          closable={false}
          extra={
            <Button
              type="text"
              icon={<CloseOutlined />}
              onClick={() => setNoteDrawerOpen(false)}
            />
          }
        >
          <div className="container">
            <div className="row">
              {notesLoading ? (
                <div className="text-center">
                  <Spin />
                </div>
              ) : (
                <>
                  {/* Add Note Form */}
                  {editingNoteId === null && (
                    <>
                      <div className="col-12 mb-2">
                        <textarea
                          className="form-control"
                          rows="3"
                          placeholder="Enter your note here..."
                          value={noteData.description}
                          onChange={(e) =>
                            setNoteData((prev) => ({
                              ...prev,
                              description: e.target.value,
                            }))
                          }
                        />
                      </div>

                      <div className="col-12 text-end mb-2">
                        <button
                          className="btn btn-primary"
                          onClick={handleAddNote}
                          disabled={addNoteLoading}
                        >
                          {addNoteLoading ? (
                            <>
                              <span className="spinner-border spinner-border-sm me-2"></span>
                              Adding...
                            </>
                          ) : (
                            "Add Note"
                          )}
                        </button>
                      </div>
                    </>
                  )}

                  {/* Notes List or Empty */}
                  {notes.length > 0 ? (
                    <div className="mt-2">
                      {notes.map((note) => (
                        <div
                          key={note.id}
                          className="card border-0 shadow mb-3"
                        >
                          <div className="card-body">
                            {editingNoteId === note.id ? (
                              <>
                                <textarea
                                  rows={4}
                                  className="form-control mb-3"
                                  value={editNoteData.description}
                                  onChange={(e) =>
                                    setEditNoteData({
                                      description: e.target.value,
                                    })
                                  }
                                />

                                <div className="d-flex justify-content-end gap-2">
                                  <button
                                    className="btn btn-light"
                                    onClick={handleCancelEdit}
                                    disabled={updateNoteLoading}
                                  >
                                    Cancel
                                  </button>

                                  <button
                                    className="btn btn-primary"
                                    onClick={handleUpdateNote}
                                    disabled={updateNoteLoading}
                                  >
                                    {updateNoteLoading ? (
                                      <>
                                        <span className="spinner-border spinner-border-sm me-2"></span>
                                        Updating...
                                      </>
                                    ) : (
                                      "Update"
                                    )}
                                  </button>
                                </div>
                              </>
                            ) : (
                              <>
                                <div className="d-flex justify-content-between">
                                  <p className="mb-2">{note.description}</p>
                                  <button
                                    className="btn btn-sm btn-outline-secondary btn-icon"
                                    onClick={() => handleEditNote(note)}
                                  >
                                    <i className="fa-solid fa-pen-to-square"></i>
                                  </button>
                                </div>

                                <div className="d-flex justify-content-between align-items-center">
                                  <div>
                                    <small className="text-muted me-3">
                                      <i className="fa-regular fa-user me-2"></i>
                                      {note.added_by_name}
                                    </small>

                                    <small className="text-muted">
                                      <i className="fa-regular fa-calendar me-2"></i>
                                      {dayjs(note.dateadded).format(
                                        "DD-MM-YYYY hh:mm A"
                                      )}
                                    </small>
                                  </div>
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="col-12">
                      <Empty description="No notes found" />
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </Drawer>

        <Drawer
          title="Reminders"
          open={reminderDrawerOpen}
          onClose={handleCloseReminderDrawer}
          width={550}
          destroyOnClose
          maskClosable={true}
          closable={false}
          extra={
            <Button
              type="text"
              icon={<CloseOutlined />}
              onClick={() => setReminderDrawerOpen(false)}
            />
          }
        >
          {/* Add / Edit Form */}

          {editingReminderId === null ? (
            <>
              <Input.TextArea
                rows={3}
                placeholder="Reminder description"
                value={reminderData.description}
                onChange={(e) =>
                  setReminderData((prev) => ({
                    ...prev,
                    description: e.target.value,
                  }))
                }
              />

              <div className="row mt-3">
                <div className="col-md-6">
                  <DatePicker
                    showTime
                    className="w-100"
                    value={reminderData.date}
                    onChange={(value) =>
                      setReminderData((prev) => ({
                        ...prev,
                        date: value,
                      }))
                    }
                  />
                </div>

                <div className="col-md-6">
                  <TagSelector
                    className="w-100"
                    style={{ height: 38 }}
                    placeholder="Select Staff"
                    loading={staffLoading}
                    value={reminderData.staff}
                    onChange={(value) =>
                      setReminderData((prev) => ({
                        ...prev,
                        staff: value,
                      }))
                    }
                    options={staffList.map((staff) => ({
                      value: staff.staffid,
                      label: `${staff.firstname} ${staff.lastname}`,
                    }))}
                  />
                </div>
              </div>

              <div className="text-end mt-3">
                <Button
                  type="primary"
                  loading={addReminderLoading}
                  onClick={handleAddReminder}
                >
                  Add
                </Button>
              </div>
            </>
          ) : (
            <>
              {/* Edit Form */}
              <Input.TextArea
                rows={3}
                value={editReminderData.description}
                onChange={(e) =>
                  setEditReminderData((prev) => ({
                    ...prev,
                    description: e.target.value,
                  }))
                }
              />
              <div className="row mt-3">
                <div className="col-md-6">
                  <DatePicker
                    showTime
                    className="w-100 mt-3"
                    value={editReminderData.date}
                    onChange={(value) =>
                      setEditReminderData((prev) => ({
                        ...prev,
                        date: value,
                      }))
                    }
                  />
                </div>
                <div className="col-md-6">
                  <TagSelector
                    className="w-100 mt-3"
                    style={{ height: 38 }}
                    value={editReminderData.staff}
                    onChange={(value) =>
                      setEditReminderData((prev) => ({
                        ...prev,
                        staff: value,
                      }))
                    }
                    options={staffList.map((staff) => ({
                      value: staff.staffid,
                      label: `${staff.firstname} ${staff.lastname}`,
                    }))}
                  />
                </div>
              </div>
              <div className="text-end mt-3">
                <Button className="me-2" onClick={handleCancelReminderEdit}>
                  Cancel
                </Button>

                <Button
                  type="primary"
                  loading={updateReminderLoading}
                  onClick={handleUpdateReminder}
                >
                  Update
                </Button>
              </div>
            </>
          )}

          <Divider>Reminder List</Divider>

          {remindersLoading ? (
            <div className="text-center py-4">
              <Spin />
            </div>
          ) : reminders.length > 0 ? (
            reminders.map((reminder) => (
              <Card key={reminder.id} size="small" className="mb-3 shadow">
                <div className="d-flex justify-content-between">
                  <div>
                    <div>{reminder.description}</div>

                    <div className="d-flex align-items-center gap-3 text-muted mt-2">
                      <small>
                        <i className="fa fa-user me-2"></i>
                        {reminder.firstname} {reminder.lastname}
                      </small>

                      <small>
                        <i className="fa fa-calendar me-2"></i>
                        {dayjs(reminder.date).format("DD-MM-YYYY hh:mm A")}
                      </small>
                    </div>
                  </div>

                  <Button
                    type="text"
                    icon={<EditOutlined />}
                    onClick={() => handleEditReminder(reminder)}
                  />
                </div>
              </Card>
            ))
          ) : (
            <Empty description="No reminders found" />
          )}
        </Drawer>

        
          <Drawer
            title="Activity Log"
            placement="right"
            width={550}
            open={activityDrawerOpen}
            onClose={() => setActivityDrawerOpen(false)}
            destroyOnClose
            maskClosable={true}
            closable={false}
            extra={
              <Button
                type="text"
                icon={<CloseOutlined />}
                onClick={() => setActivityDrawerOpen(false)}
              />
            }
          >
            {activityLoading ? (
              <div className="text-center py-5">
                <Spin size="large" />
              </div>
            ) : activityLog ? (
              <div className="activity-log">
                {/* User Information */}
                <div className="border rounded p-3 mb-3">
                  <div className="d-flex align-items-center">
                    <Avatar size={55} />

                    <div className="ms-3">
                      <h6 className="mb-1 fw-bold">
                        {activityLog.StaffName || "Unknown User"}
                      </h6>

                      <div className="text-muted">
                        <i className="fa-regular fa-calendar me-2"></i>
                        {activityLog.date
                          ? dayjs(activityLog.date).format("DD MMM YYYY")
                          : "-"}
                      </div>

                      <div className="text-muted">
                        <i className="fa-regular fa-clock me-2"></i>
                        {activityLog.date
                          ? dayjs(activityLog.date).format("hh:mm A")
                          : "-"}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Activity Details */}
                <div className="border rounded p-3">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <Tag color="green">Activity</Tag>

                    {/* Optional ID */}
                    {/* <span className="text-muted">
              #{activityLog.id}
            </span> */}
                  </div>

                  <h6 className="fw-semibold mb-0">
                    {activityLog.description || "No activity description"}
                  </h6>
                </div>
              </div>
            ) : (
              <div className="text-center text-muted py-5">
                No activity found
              </div>
            )}
          </Drawer>
 
        <CommonFooter />
      </div>
    </div>
  );
};

export default EstimateInfo;
